export * from './appLinks'
export * from './firebase'

export const defaultFormId = process.env.REACT_APP_DEFAULT_FORM_ID
export const homeUrl = process.env.REACT_APP_HOME_URL
export const logoUrl = process.env.REACT_APP_LOGO_LINK
export const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL



// WEBPACK FOOTER //
// ./src/config/index.ts